export default __webpack_public_path__ + "static/media/nike_stimuli_fr_phone.0cc2a98f.mp4";